const CloseButton = ({clickHandler}) => {
    return <span className="close-modal-btn" onClick={clickHandler}>&times;</span>;
};

export default CloseButton;